export const capitalizeLeadingText = (value) => {
  if (typeof value !== "string") return value;

  return value.replace(/^(\s*)([a-z])/, (_, leadingWhitespace, firstChar) => {
    return `${leadingWhitespace}${firstChar.toUpperCase()}`;
  });
};
